











import Vue from "vue";
import { mapState } from "vuex";
import { getInstallationPredictedStatusIconColor } from "@/utility/Constants";
import { installationPredictedStatusEnumLabel } from "@/model/data/predictiveMaintenance/InstallationPredictedStatusEnum";

export default Vue.extend({
    props: {
        status: Number,
        outlined: {
            type: Boolean,
            default: true,
        },
        isNew: Boolean,
    },
    methods: {
        installationPredictedStatusEnumLabel,
        getInstallationPredictedStatusIconColor,
    },
});
